import { createApp } from 'vue'
import App from './App.vue'
import "normalize.css";
// import "../src/assets/reset.css"
import  'amfe-flexible'
import router from './router'
import store from './store';
import VueAwesomeSwiper from 'vue-awesome-swiper';
// import 'swiper/css';

import './untils/overall.css'
import 'animate.css'
import animated from  'animate.css/animate.min.css'
import "wow.js/css/libs/animate.css";

import VueDPlayer from "vue-dplayer";
import "vue-dplayer/dist/vue-dplayer.css";

import AnimatedNumber from 'animated-number-vue3'

// createApp(App,router).mount('#app')
const app = createApp(App)
app.use(router) //注册路由
app.use(store) 
app.use(VueDPlayer) 
app.use(animated)
app.use(AnimatedNumber)
app.use(VueAwesomeSwiper)
app.mount('#app')